// Partner.js
import React, { useState, useEffect, useRef  } from "react";
import { useAuth } from "../AuthContext";
import "../styles/Partner.css";
import PartnerRegisterModal from "./PartnerRegisterModal";
import PartnerEditModal from "./PartnerEditModal";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Partner = () => {
    //const { user, setUser } = useAuth();
    const { user } = useAuth();
    const [users, setUsers] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const pageSize = 10;    
    const [isModalOpen, setIsModalOpen] = useState(false); // 모달 상태 관리
    const [searchField, setSearchField] = useState("all");  // 라디오 버튼에서 선택된 항목
    const [searchKeyword, setSearchKeyword] = useState("");  // 검색 키워드
    const [selectedPartner, setSelectedPartner] = useState(null);
    const [glist, setGlist] = useState([]);
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return; // 이미 실행되었으면 종료
        hasRun.current = true; // 첫 실행 후 플래그 설정
        
        getGovernmentCode();
        
    }, []);

    // 파트너 코드 리스트 가져오기
    const getGovernmentCode = async () => {

        try {
            const response = await fetch(`${API_BASE_URL}/api/Government/get-list`);
            const data = await response.json();

            if (response.ok) {
                setGlist(data.glist);
                //console.log(data.glist);
            } else {
                alert(data.message || "조회 실패");
            }

        } catch (error) {
            alert("관공서 리스트 조회 중 오류가 발생했습니다.");
        }
    };

    const handleRowClick = (Partner) => {
        setSelectedPartner(Partner);
    };

    const handleSavePartner = (updatedPartner) => {
        setUsers(users.map((u) => (u.snum === updatedPartner.snum ? updatedPartner : u)));
    };

    const handleSearch = () => {
        fetchUsers(searchField, searchKeyword);  // 필터링된 값으로 다시 fetch 호출
    };

    const handleSearchFieldChange = (e) => {
        const selectedValue = e.target.value;
        setSearchField(e.target.value);  // 선택된 콤보박스 값 설정
        // "회원구분"을 선택하면 기본값 설정
        if (selectedValue === "userType") {
            setSearchKeyword("S"); // 기본값을 "S"로 설정 (빛담관리자)
        } else {
            setSearchKeyword(""); // 다른 경우 입력값 초기화
        }
    };

    const handleSearchKeywordChange = (e) => {
        setSearchKeyword(e.target.value);  // 검색어 값 설정
    };
    /*
    const handleUserTypeChange = (e) => {
        setSearchKeyword(e.target.value); // 선택한 값(S, P, G, U) 저장
    };
    */
    /*
    const fetchUsers = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/api/Partner/get-partners?page=${page}&pageSize=${pageSize}`);
            const data = await response.json();
            //console.log("서버 응답:", data); // 응답 구조 확인

            if (response.ok) {
                setUsers(data.users);
                setTotalPages(Math.ceil(data.totalRecords / pageSize)); // 총 페이지 수 계산
            } else {
                alert(data.message || "조회 실패");
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };
    */

    // 기존의 fetchUsers 함수에 검색 필터 추가
    const fetchUsers = async (searchField, searchKeyword) => {
        try {
            const queryParams = new URLSearchParams({
                page,
                pageSize,
                searchField,
                searchKeyword                
            });

            const response = await fetch(`${API_BASE_URL}/api/Partner/get-partners?${queryParams}`);
            const data = await response.json();

            if (response.ok) {
                setUsers(data.users);
                setTotalPages(Math.ceil(data.totalRecords / pageSize));
            } else {
                console.log(data.message || "조회 실패");
            }
        } catch (error) {
            console.error("조회 실패:", error);
            alert("서버 오류 발생");
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []); // 페이지 로드 시 실행

    useEffect(() => {
        fetchUsers(searchField, searchKeyword);
    }, [page]);

    useEffect(() => {
        const validTotalPages = totalPages > 0 ? totalPages : 1; // totalPages가 0 또는 null이면 1로 설정

        if (page > validTotalPages) {
            setPage(validTotalPages);  // 현재 선택된 페이지가 전체 페이지보다 크면 마지막 페이지로 이동
        }
    }, [totalPages]);  // totalPages가 변경될 때 실행

    // ✅ 사용자 추가 후 호출될 콜백 함수
    const handlePartnerAdded = () => {
        setSearchField("");
        setSearchKeyword("");
        fetchUsers(searchField, searchKeyword);  // 사용자 추가 후 다시 목록 로드
    };

    const handleAddUserClick = () => {
        setIsModalOpen(true); // 팝업 열기
    };
    /*
    const closePopup = () => {
        setIsModalOpen(false); // 팝업 닫기
    };
    */
    const renderPagination = () => {
        if (totalPages <= 10) {
            return [...Array(totalPages)].map((_, index) => (
                <button
                    key={index + 1}
                    className={page === index + 1 ? "active" : ""}
                    onClick={() => setPage(index + 1)}
                >
                    [{index + 1}]
                </button>
            ));
        }
        let pages = [];
        if (page <= 6) {
            pages = [1, 2, 3, 4, 5, 6, 7, 8, 9, "...", totalPages];
        } else if (page >= totalPages - 5) {
            pages = [1, "...", totalPages - 8, totalPages - 7, totalPages - 6, totalPages - 5, totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
        } else {
            pages = [1, "...", page - 3, page - 2, page - 1, page, page + 1, page + 2, page + 3, "...", totalPages];
        }

        return pages.map((p, index) => (
            <button
                key={index}
                className={page === p ? "active" : ""}
                onClick={() => typeof p === "number" && setPage(p)}
                disabled={typeof p !== "number"}
            >
                [{p}]
            </button>
        ));
    };

    return (
        <div className="partner-wrapper">
            <div className="partner-header">
                {/* <h1>파트너 관리</h1> */}
                <h1>파트너관리 <span style={{ fontSize: "0.7em", color: "gray" }}>{`Admin > ${user.name}`}</span></h1>
                
                <button className="add-button" onClick={handleAddUserClick}>+</button> {/* + 버튼 */} 
            </div>
            <hr className="title-line" />

            {/* ✅ 모달 창 표시 (PartnerRegisterModal.js에 handleUserAdded 전달) */}
            {isModalOpen && <PartnerRegisterModal glist={glist} onClose={() => setIsModalOpen(false)} onPartnerAdded={handlePartnerAdded} />}

            {/* 검색 섹션 */}
            <div className="search-container">
                <label>
                    <select value={searchField} onChange={handleSearchFieldChange}>
                        <option value="all">전체조회</option>
                        <option value="partnerCode">파트너코드</option>
                        <option value="partnerName">파트너명</option>                        
                        <option value="OfficeNumber">사업자번호</option>
                        <option value="ownerName">대표자명</option>
                        <option value="addressAll">주소</option>          
                        <option value="governmentCode">관할관공서</option>     
                    </select>
                </label>

                {/* 검색어 입력 (전체조회) */}
                {searchField !== "all" && searchField !== "governmentCode" && (
                    <label>

                        <input
                            type="text"
                            value={searchKeyword}
                            onChange={handleSearchKeywordChange}
                            maxLength={18}
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch(); // 
                                }
                            }}
                        />
                    </label>
                )}
                {searchField === "governmentCode" && (
                    <label>
                        <select value={searchKeyword} onChange={handleSearchKeywordChange}>
                            <option value="">선택된 관공서 없음</option> {/* 기본값 */}
                            {glist.map((government) => (
                                <option key={government.snum} value={government.governmentCode}>
                                    {government.snum}, {government.governmentCode} : {government.governmentName}
                                </option>
                            ))}
                        </select>
                    </label>
                )}



                
                <button onClick={handleSearch}>검색</button>
            </div>

            <div className="partner-container">
                <ul className="partner-list">
                    <li className="partner-header-row">
                        <span className="snum">순번</span>
                        <span className="partnerCode">파트너코드</span>
                        <span className="partnerName">파트너명</span>      
                        
                        <span className="officeNumber">사업자번호</span>
                        <span className="ownerName">대표자명</span>
                        <span className="address1">소재지1</span>
                        {/* <span className="address2">소재지2</span> */}
                        <span className="governmentCode">관할관공서</span>
                    </li>
                    <hr className="thick-line" />

                    {users.map((Partner, index) => (
                        <React.Fragment key={Partner.snum}>
                            <li className="partner-row" onClick={() => handleRowClick(Partner)}>
                                <span className="snum">{Partner.snum}</span>
                                <span className="partnerCode">{Partner.partnerCode}</span>
                                <span className="partnerName">{Partner.partnerName}</span>      
                                
                                <span className="officeNumber">{Partner.partnerBusinessNum}</span>
                                <span className="ownerName">{Partner.representativeName}</span>
                                <span className="address1">{Partner.location1}</span>
                                {/* <span className="address2">{Partner.location2}</span>     */}
                                <span className="governmentCode">

                                    {/*  {Partner.governmentCode} */}
                                    {glist.find(government => government.governmentCode === Partner.governmentCode)?.governmentName || ''}                                                                       
                                </span>
                            </li>
                            <hr className="thin-line" />
                        </React.Fragment>
                    ))}






                    {selectedPartner && <PartnerEditModal selectedPartner={selectedPartner} glist={glist}  onClose={() => setSelectedPartner(null)} onSave={handleSavePartner} onPartnerAdded={handlePartnerAdded} />}
                    <hr className="thick-line" />
                </ul>
                <div className="pagination">{renderPagination()}</div>
            </div>




        </div>
    );
};

export default Partner;